import ArmoredVehiclesPage from "./armored-vehicles.page"

export default ArmoredVehiclesPage;
